import { useAuth } from '../../../contexts/AuthContext';
import { useFeatureFlags } from '../../../contexts/FeatureFlagContext';
import { Feature } from '../../../generated/graphql';
import IntegrationCard from '../../components/IntegrationCard';
import CalendlyLogo from '../../svgs/CalendlyLogo';
import StripeLogo from '../../svgs/StripeLogo';
import GoogleCalendarLogo from '../../svgs/GoogleCalendarLogo';
import MicrosoftOutlookLogo from '../../svgs/MicrosoftOutlookLogo';

export default function IntegrationsSection() {
  const { authedProviderUser } = useAuth();

  const { isFeatureEnabled } = useFeatureFlags();

  const isStripeIntegrationFeatureEnabled = isFeatureEnabled(
    Feature.StripeIntegration,
  );
  const isCalendarSyncEnabled = isFeatureEnabled(Feature.CalendarSync);

  return (
    <div className="grid max-w-[1080px] grid-cols-3 gap-4 py-5">
      {isCalendarSyncEnabled && (
        <IntegrationCard
          logo={
            <div className="flex items-center space-x-2.5">
              <div className="flex flex-row items-center gap-x-2">
                <GoogleCalendarLogo className="h-8 w-8 flex-shrink-0" />
                <MicrosoftOutlookLogo className="h-8 w-8 flex-shrink-0" />
              </div>
              <span className="text-subtitle-small font-light text-green-150 line-clamp-2">
                Calendar sync
              </span>
            </div>
          }
          name="Calendar sync"
          description={
            <div>
              Sync your Google Workspace or Microsoft Outlook calendar with
              Homecoming to view all your events in one place.
            </div>
          }
          isConnected={Boolean(authedProviderUser?.hasNylasIntegration)}
          integrationPath="/integrations/calendar"
        />
      )}
      {isStripeIntegrationFeatureEnabled && (
        <IntegrationCard
          logo={<StripeLogo className="h-8" />}
          name="Stripe"
          description="Send and track client invoices, and notify clients of past due invoices."
          isConnected={Boolean(authedProviderUser?.provider.stripeAccountId)}
          integrationPath="/integrations/stripe"
        />
      )}
      <IntegrationCard
        logo={<CalendlyLogo className="h-8" />}
        name="Calendly"
        description="Sync your calendar with Homecoming and allow clients to schedule sessions."
        isConnected={Boolean(authedProviderUser?.provider.calendlyIntegration)}
        integrationPath="/integrations/calendly"
      />
    </div>
  );
}
